module.exports = __webpack_public_path__ + "static/media/carousal1.ea496bab.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousal1.png
// module id = 308
// module chunks = 0